import { __decorate, __metadata } from "tslib";
import { SerializableArrayMember, SerializableMember, SerializableObject } from '@openhps/core';
import { tree } from '../../terms';
import { SerializableThing } from '@openhps/rdf';
import { Relation } from './Relation';
import { Collection } from './Collection';
let Node = class Node extends SerializableThing {
    constructor(iri) {
        super(iri);
        this.relations = [];
    }
    getChildNodes() {
        return this.relations.map((r) => r.node);
    }
    /**
     * Get child node
     * @param value
     * @returns Child node if found
     */
    getChildNode(value) {
        const relations = this.relations.filter((r) => {
            return r ? r.value && r.test(value) : false;
        });
        if (relations.length === 0) {
            return null;
        }
        // Sort the nodes by value in decending order
        // Since value can be anything, assume its either a number, date or string
        const nodes = relations
            .sort((a, b) => {
            if (typeof a.value === 'number' && typeof b.value === 'number') {
                return a.value - b.value;
            }
            else if (a.value instanceof Date && b.value instanceof Date) {
                return a.value.getTime() - b.value.getTime();
            }
            else {
                return a.value.toString().localeCompare(b.value.toString());
            }
        })
            .map((r) => r.node);
        // Select the node that with the highest value
        return nodes[nodes.length - 1];
    }
};
__decorate([
    SerializableArrayMember(Relation, {
        rdf: {
            predicate: tree.relation,
        },
    }),
    __metadata("design:type", Array)
], Node.prototype, "relations", void 0);
__decorate([
    SerializableMember({
        rdf: {},
    }),
    __metadata("design:type", Collection)
], Node.prototype, "collection", void 0);
Node = __decorate([
    SerializableObject({
        rdf: {
            type: tree.Node,
        },
    }),
    __metadata("design:paramtypes", [String])
], Node);
export { Node };
//# sourceMappingURL=Node.js.map